import React from 'react';
import PropTypes from 'prop-types';

import useDismissiblePersistent from '../../../../../../../hooks/useDismissiblePersistent';
import { STORE_NAMESPACE } from '../../../../../../../components/global/DismissiblePersistent';
import NoticeModal from './components/NoticeModal';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
    picture_day_enabled: PropTypes.bool,
    has_charity: PropTypes.bool,
    charity_description: PropTypes.string,
  }),
};

const CharityNotice = ({ albumFolder }) => {
  const { visible, onDismiss } = useDismissiblePersistent(
    `${STORE_NAMESPACE}_CHARITY_NOTICE_${albumFolder?.id}`,
  );

  if (!albumFolder?.picture_day_enabled || !albumFolder.has_charity) {
    return null;
  }

  return visible ? (
    <NoticeModal forceOpen albumFolder={albumFolder} onViewPhotos={onDismiss} />
  ) : null;
};

CharityNotice.propTypes = propTypes;

export default CharityNotice;
